<template>
  <nav class="nav">
    <aside class="logo">
      <router-link to="/">
        <img
          src="https://res.cloudinary.com/dyikvzcke/image/upload/v1755469812/LOGO_SKF_1-removebg-preview_zfcosc.webp"
          alt="Logo de Rodamientos Huanuco"
          class="logo-max"
        />
        <img
          src="https://res.cloudinary.com/dyikvzcke/image/upload/v1755469968/LOGO_SKF_1_1_-removebg-preview_l56vp1.webp"
          alt="Logo de Rodamientos Huanuco"
          class="logo-min"
        />
      </router-link>
    </aside>
    <aside class="bottom-nav">
      <ul>
        <li><router-link to="/">Inicio</router-link></li>
        <li><router-link to="/acerca-de">Acerca de</router-link></li>
        <li class="item-products">
          <a>Productos &nbsp; <font-awesome-icon :icon="faCaretDown" /> </a>
          <div class="content-categories">
            <div class="items">
              <aside class="left">
                <h4>Categorias</h4>
              </aside>

              <aside class="rigth">
                <ul class="categories">
                  <ul
                    v-for="category in categories"
                    :key="category.id"
                    class="subcategories"
                  >
                    <router-link
                      :to="`/productos?categories=${category.id}`"
                      class="text-category"
                      >{{ category.name }}</router-link
                    >
                    <li
                      v-for="subcategory in category.subcategories"
                      :key="subcategory.id"
                    >
                      <a href="#">{{ subcategory.name }}</a>
                    </li>
                  </ul>
                </ul>
              </aside>
            </div>
            <div class="btn more-allproducts">
              <button @click="onRedirectProducts()">
                Ver todos los productos
              </button>
            </div>
          </div>
        </li>
      </ul>
    </aside>
    <aside class="aside aside-rigth">
      <button class="btn btn-primmary">Cotizar ahora</button>
      <button class="btn btn-shopping" @click="navigateToCart">
        <p class="quantity-products">{{ cartShop.cart.length }}</p>
        <img
          src="@/assets/icons/shopping_bag.svg"
          alt="Icon carrito de compras"
        />
      </button>
    </aside>

    <!-- Mobile Nav -->
    <div class="nav-mobile">
      <div class="nav-bar">
        <button @click="toggleMenuMobile">
            <font-awesome-icon :icon="faBars" size="2x" style="color: #2273b8" />
        </button>
        <button class="btn btn-shopping" @click="navigateToCart">
          <p class="quantity-products">{{ cartShop.cart.length }}</p>
          <img
            src="@/assets/icons/shopping_bag.svg"
            alt="Icon carrito de compras"
          />
        </button>
      </div>
      <div class="nav-menu__mobile" v-if="showMenuMobile">
        <ul>
          <li><router-link to="/">Inicio</router-link></li>
          <li><router-link to="/acerca-de">Acerca de</router-link></li>
          <li><router-link to="/productos">Productos</router-link></li>
          <button class="btn btn-primmary">Cotizar ahora</button>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" setup>
import { useCartShoppingStore } from "@/store/cartshopping";
import categories from "@/data/categories.json";
import { faBars, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useRouter } from "vue-router";
import { ref } from "vue";

const router = useRouter();
const cartShop = useCartShoppingStore();
const showMenuMobile = ref(false);

function navigateToCart() {
  router.push("/compra");
}
function onRedirectProducts() {
  router.push({ name: "productos" });
}

function toggleMenuMobile() {
  showMenuMobile.value = !showMenuMobile.value;
}
</script>

<style lang="scss" scoped>
.nav {
  background-color: $whited;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-inline: 300px;
  padding-block: 12px;
  padding-bottom: 20px;
  position: sticky;
  top: 0;
  z-index: 10;
  .logo {
    &-max {
      display: block;
      width: 280px;
    }
    .logo-min {
      display: none;
      width: 56px;
    }
  }
  .aside-rigth {
    display: flex;
    flex-direction: row;
    gap: 20px;
    height: fit-content;
    button {
      border: none;
      background: transparent;
      cursor: pointer;
    }
    .btn-primmary {
      font-size: 16px;
      font-weight: 500;
      font-family: $fontFamily;
      padding: 10px 35px;
      border-radius: 12px;
      background: $colorPrimary;
      color: $whited;
    }
    .btn-shopping {
      position: relative;
      padding: 10px 20px;
      border-radius: 12px;
      border: 2px solid var(--primary, #2273b8);
      .quantity-products {
        position: absolute;
        top: -10px;
        right: -10px;
        background-color: var(--primary, #2273b8);
        color: white;
        padding: 2px 6px;
        border-radius: 50%;
        font-size: 12px;
      }
    }
  }
}

.bottom-nav ul {
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  padding-block: 20px;
  li a {
    white-space: nowrap;
    padding-inline: 12px;
    padding-block: 4px;
    border-radius: 5px;
    color: var(--sps-4, #071725);
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    text-decoration: none;
  }
  li a:hover {
    padding-inline: 12px;
    padding-block: 4px;
    border-radius: 5px;
    background-color: rgba(128, 128, 128, 0.116);
  }
  .item-products .content-categories {
    display: none;
    //background-color: #f5faff !important;
    border-radius: 10px;
    overflow: hidden;
  }
  .item-products:hover .content-categories {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $whited;
    position: absolute;
    padding-top: 20px;
    padding-inline: 0px;
    left: 300px;
    box-shadow: 0px 0px 5.3px -3px rgba(34, 115, 184, 0.1);
    z-index: 5;

    .items {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 300px;
      height: 400px;
    }
    .left {
      padding-left: 100px;
    }
    .left h4 {
      font-size: 28px;
      color: $blacked;
    }
    .rigth {
      overflow-y: scroll;
      height: 400px;
      scrollbar-width: thin;
      scrollbar-color: $tint1 #ffffff;
      padding-right: 100px;
      ::-webkit-scrollbar-thumb {
        border-radius: 5px;
        border: 25px inset #ffffff;
      }
    }
    .rigth ul {
      padding-inline: 0px;
      display: flex;
      align-items: start;
      flex-direction: column;
      gap: 10px;
      .subcategories li {
        margin-left: 30px;
      }
      .subcategories .text-category {
        font-weight: 700;
      }
    }
    .more-allproducts {
      width: 100%;
      button {
        border: none;
        outline: none;
        background-color: $tint2;
        color: $whited;
        font-weight: 600;
        padding-block: 20px;
        width: inherit;
        &:hover {
          background-color: $tint1;
        }
      }
    }
  }
}
.nav-mobile {
    display: none;
}

@media (max-width: 1600px) {
  .nav {
    padding-inline: 100px;
  }
  .bottom-nav ul {
    padding-inline: 100px;
    .item-products .content-categories {
      left: 100px !important;
    }
  }
}

@media (max-width: 1400px) {
  .nav {
    .logo {
      .logo-max {
        display: none;
      }
      .logo-min {
        display: block;
      }
    }
  }
}

@media (max-width: 1080px) {
  .bottom-nav ul {
    padding-inline: 80px;
    .item-products .content-categories {
      left: 80px !important;
      .items {
        gap: 100px !important;
      }
      .left {
        padding-left: 50px !important;
      }
    }
  }
}

@media (max-width: 780px) {
  .bottom-nav ul {
    justify-content: space-between;
    gap: 10px;
    .item-products .content-categories {
      display: none !important;
    }
  }
}

@media (max-width: 580px) {
  .bottom-nav ul {
    padding-inline: 20px;
    overflow-x: scroll;
    scrollbar-width: thin;
    scrollbar-color: $tint1 #ffffff;
    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      border: 25px inset #ffffff;
    }
  }
}

@media (max-width: 1080px) {
  .nav {
    padding-inline: 80px;
    .logo {
      .logo-max {
        display: none;
      }
      .logo-min {
        display: block;
      }
    }
    .bottom-nav,
    .aside-rigth {
      display: none;
    }
    .nav-mobile {
        display: block;
    }
    .nav-mobile .nav-bar {
      display: flex;
      flex-direction: row;
      gap: 20px;
      align-items: center;
      button {
        border: none;
        background: transparent;
        cursor: pointer;
      }
      .btn-shopping {
        position: relative;
        padding: 10px 20px;
        border-radius: 5px;
        border: 2px solid var(--primary, #2273b8);
        .quantity-products {
          position: absolute;
          top: -10px;
          right: -10px;
          background-color: var(--primary, #2273b8);
          color: white;
          padding: 2px 6px;
          border-radius: 50%;
          font-size: 12px;
        }
      }
    }
    .nav-mobile .nav-menu__mobile {
      background-color: $whited;
      width: 100%;
      display: block;
      position: absolute;
      top: 85px;
      left: 0;
      padding: 20px;
      cursor: pointer;
      z-index: 10;
      ul {
        list-style: none;
      }
      ul {
        list-style: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        padding-block: 20px;
        li a {
          white-space: nowrap;
          padding-inline: 12px;
          padding-block: 4px;
          border-radius: 5px;
          color: var(--sps-4, #071725);
          font-size: 16px;
          font-weight: 400;
          line-height: normal;
          text-decoration: none;
        }
        li a:hover {
          padding-inline: 12px;
          padding-block: 4px;
          border-radius: 5px;
          background-color: rgba(128, 128, 128, 0.116);
        }
      }
      ul {
        button {
          border: none;
          background: transparent;
          cursor: pointer;
        }
        .btn-primmary {
          font-size: 16px;
          font-weight: 500;
          font-family: $fontFamily;
          padding: 10px 35px;
          border-radius: 5px;
          background: $colorPrimary;
          color: $whited;
        }
      }
    }
  }
}

@media (max-width: 780px) {
  .nav {
    .aside-rigth {
      .btn-primmary {
        padding: 10px 40px;
      }
    }
  }
}
@media (max-width: 580px) {
  .nav {
    padding-inline: 20px;
    .aside-rigth {
      .btn-primmary {
        padding: 10px 20px;
      }
    }
  }
}
</style>
